import { useState } from 'react';
import { toast } from 'sonner';
import { proposalProjectApiConnect } from '../../../../lib/api/proposalProjectApi.connect';
import { useProcessingJobsStore } from '../../../../lib/processing/jobsStore';
/** Starts a fast re-extract job and registers it in the processing tray. */ export function useReextractContract() {
    const registerJob = useProcessingJobsStore((s)=>s.registerJob);
    const [running, setRunning] = useState(false);
    const reextract = async (opts)=>{
        if (!opts.zouProjectId || !opts.reextractDocId || running) {
            if (!opts.zouProjectId) {
                toast.error('No project linked to this program — re-extract unavailable.');
            } else if (!opts.reextractDocId) {
                toast.error('No processed document found for re-extract.');
            }
            return;
        }
        setRunning(true);
        try {
            const batch = await proposalProjectApiConnect.reprocessContractExtraction(opts.zouProjectId, opts.reextractDocId, {
                documentKind: opts.documentKind,
                programId: opts.programId
            });
            registerJob({
                batchId: batch.batchId,
                zouProjectId: opts.zouProjectId,
                kind: 'contract-docs',
                label: opts.label,
                link: opts.link
            });
            toast.success('Re-extract started — watch the processing tray for progress.');
        } catch (err) {
            toast.error(err instanceof Error ? err.message : 'Re-extract failed to start');
        } finally{
            setRunning(false);
        }
    };
    return {
        reextract,
        running
    };
}
